import * as d3 from 'd3-selection'
import * as colors from 'colors'

const gradients = chartId => {
  return d => {
    let grads = []

    // We have to add gradients for the color if it was a top stage and if it's
    // a lower stage in case there are duplicate colors in the pyramid.

    // Top stage gradient color
    grads.push({
      id: `${chartId}-pyramid-top-left-${d}`,
      clazz: `pyramid-top-left pyramid-top-left-${d}`,
      type: 'radialGradient',
      stops: [{
        offset: '10%',
        color: colors.adjustLightness(colors.lookup(d), 30)
      }, {
        offset: '90%',
        color: colors.adjustLightness(colors.lookup(d), -5)
      }],
      attrs: {
        cx: 1,
        cy: 0,
        r: 1.5
      }
    })

    grads.push({
      id: `${chartId}-pyramid-top-right-${d}`,
      clazz: `pyramid-top-right pyramid-top-right-${d}`,
      type: 'linearGradient',
      stops: [{
        offset: '0%',
        color: colors.adjustLightness(colors.lookup(d), -5)
      }, {
        offset: '90%',
        color: colors.adjustLightness(colors.lookup(d), -20)
      }],
      attrs: {
        x1: .25,
        x2: .75,
        y1: .3,
        y2: 1
      }
    })

    // Base colors
    grads.push({
      id: `${chartId}-pyramid-left-${d}`,
      clazz: `pyramid-left pyramid-left-${d}`,
      type: 'radialGradient',
      stops: [{
        offset: '30%',
        color: colors.adjustLightness(colors.lookup(d), 30)
      }, {
        offset: '100%',
        color: colors.lookup(d)
      }],
      attrs: {
        cx: .6,
        cy: .3,
        r: .85
      }
    })

    grads.push({
      id: `${chartId}-pyramid-right-${d}`,
      clazz: `pyramid-right pyramid-right-${d}`,
      type: 'linearGradient',
      stops: [{
        offset: '20%',
        color: colors.lookup(d)
      }, {
        offset: '90%',
        color: colors.adjustLightness(colors.lookup(d), -20)
      }],
      attrs: {
        x1: .25,
        x2: .75,
        y1: .2,
        y2: 1
      }
    })

    grads.push({
      id: `${chartId}-pyramid-lid-${d}`,
      clazz: `pyramid-lid pyramid-lid-${d}`,
      type: 'linearGradient',
      stops: [{
        offset: '0%',
        color: colors.adjustLightness(colors.lookup(d), 5)
      }, {
        offset: '100%',
        color: colors.adjustLightness(colors.lookup(d), -10)
      }],
      attrs: {
        x1: 0,
        x2: 1,
        y1: .5,
        y2: .5
      }
    })

    return grads
  }
}

export default (selection, chartId, colors, transition) => {
  selection.each(function () {
    let container = d3.select(this)
      , group = container.selectAll('g.pyramid-gradient-group')
                          .data(colors, d => d)
      , grads = group.enter()
                      .append('g')
                      .attr('class', 'pyramid-gradient-group')
                      .merge(group)
                      .selectAll('.pyramid-colored-gradient')
                      .data(gradients(chartId))
      , enter = grads.enter()
                     .append(d => {
                       return document.createElementNS('http://www.w3.org/2000/svg', d.type)
                     })

    enter.attr('id', d => d.id)
         .attr('class', d => `pyramid-colored-gradient ${d.clazz}`)
         .select(function (d) {
           for (const [key, value] of Object.entries(d.attrs)) {
             d3.select(this).attr(key, value)
           }
         })

    enter.selectAll('stop')
         .data(d => d.stops)
         .enter()
         .append('stop')
           .attr('offset', d => d.offset)
           .attr('stop-color', d => d.color)

    transition.end().then(() => {
      group.exit().remove()
    }).catch(() => {
      // interrupted transition, ignore
    })
  })
}
